module.exports = __webpack_public_path__ + "static/pt-serif-v12-latin-regular-d099b509e40bccf1a0a7e03b26cc5d50.woff2";